import { configCategory } from "@pub/config";
import { Ads, CustomClassContext } from "@sphtech/dmg-design-system";
import cx from "classnames";
import { ReactNode, useContext } from "react";

import styles from "../category.module.css";
import SubAnchor from "../SubAnchor";
import SubAnchorVideo from "../SubAnchorVideo";
import { CategoryLayoutElementProps } from "../types/types";
import CategorySidebar from "./CategorySidebar";

export default function CategorySubAnchorBlockWithVideo({
  data,
}: CategoryLayoutElementProps): ReactNode {
  const customClass = useContext(CustomClassContext);
  const sectionContainerClass = customClass?.categoryLayout?.sectionContainer;
  const mobileAdBeforeVideoGallery =
    !!data.uniqSectionName && configCategory.videoGalleryLandscape?.display;

  if (!data.latestArticle?.length) {
    return null;
  }

  return (
    <section
      className={cx(
        styles.bodyContainer,
        styles.gutterBottom,
        sectionContainerClass,
      )}
    >
      <div className={styles.latestTeaserContainer}>
        <div className={styles.latestTeaserLayout}>
          <SubAnchor articleList={data.latestArticle} />
          {mobileAdBeforeVideoGallery && (
            <div className={styles.mobileAdvertisement}>
              <Ads.AdsSideBarMobile />
            </div>
          )}
          {mobileAdBeforeVideoGallery && (
            <SubAnchorVideo videoGallery={data.videoGallery} />
          )}
        </div>

        <CategorySidebar data={data} />
      </div>
    </section>
  );
}
